<template>
  <div class="container-fluid catalog-sections-page">
    <el-container>
      <el-header height="15%">
        <el-row>
          <h4>{{ getTitle }}</h4>
        </el-row>
        <el-row>
          <div v-if="query.sectionId" class="catalog-sections-page__top-buttons">
            <el-button @click="onParentSection" v-loading="isSelectedLoading">
              К родительской категории
            </el-button>
            <el-button @click="onRootSection">
              Сбросить
            </el-button>
          </div>
        </el-row>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск">
          <el-row>
            <el-col :span="12">
              <el-form-item label="Поиск">
                <el-col :span="14">
                  <el-input v-model="query.q" @change="onSearch"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Сортировка">
                <el-select v-model="tempSort" :width="300" placeholder="Сортировка" no-data-text="Нет данных" clearable
                  @change="onSort">
                  <el-option v-for="item in sortConfig" :key="item.field" :value="item.field" :label="item.title" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="sections" style="width: 100%" empty-text="Нет данных">
          <el-table-column prop="id" label="Id" width="64" />
          <el-table-column prop="title" label="Название" width="380">
            <template slot-scope="scope">
              <el-button type="text" class="button-name-section" @click="onSection(scope.row.id)">
                {{ scope.row.title }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="products_count" label="Кол-во тов." />
          <el-table-column prop="sort" label="Сортировка" />
          <el-table-column prop="activity" label="Активность">
            <template slot-scope="scope">
              <p v-if="!scope.row.activity">Нет</p>
              <p v-if="scope.row.activity">Да</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Действия" width="300">
            <template slot-scope="scope">
              <el-row>
                <el-button size="mini" @click="onUpdateRow(scope.$index)">Изменить</el-button>
                <el-button size="mini" v-if="scope.row.activity" @click="onHide(scope.row.id)">Скрыть</el-button>
                <el-button size="mini" v-else @click="onShow(scope.row.id)">Показать</el-button>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination background layout="prev, pager, next" :total="paginator ? paginator.total : 0"
          :current-page.sync="paginator.current_page" @current-change="onPage(paginator ? paginator.current_page : 0)"
          :hide-on-single-page="true" :page-size="paginator ? paginator.per_page : 0"
          :page-count="paginator ? paginator.last_page : 0" />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from '@/store/mutation-types'
import sortConfig from "../../composable/config/catalog-section-sort.config"

export default {
  data: function () {
    return {
      sections: [],
      isSelectedLoading: false,
      sortConfig,
      selectedSection: {
        title: '',
        id: 0,
        parentId: 0,
      },
      query: {
        page: 1,
        sectionId: 0,
        q: '',
        sort: '',
      },
      tempSort: '',
      paginator: {},
    }
  },
  mounted() {
    this.initParams(this.$route.query)
    this.initSections()
  },
  computed: {
    getTitle() {
      if (this.selectedSection.title) {
        return this.selectedSection.title
      }
      return 'Разделы каталога'
    }
  },
  watch: {
    '$route.query'() {
      this.initParams(this.$route.query)
      const query = this.getQuery()
      if (query && this.query.q) {
        this.searchRequest(query)
      } else if (query) {
        this.fetch(query)
      }
    }
  },
  methods: {
    async fetchDetailSection() {
      const sectionId = this.query.sectionId;
      if (!sectionId) {
        return;
      }
      this.isSelectedLoading = true
      axios.get(`catalog/section/${sectionId}`)
        .then((response) => {
          this.setSelectedSection(response.data)
        })
        .catch(() => { })
        .finally(() => this.isSelectedLoading = false)
    },
    async fetch(query) {
      this.$store.commit(SETPRELOADER_STATE, true)

      await axios.get('catalog/section/by-parent' + query)
        .then((response) => {
          this.sections = response.data?.data;
          this.paginator = response.data?.meta ?? {};
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push('/login');
          }
        })
        .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
    },
    async searchRequest(query) {
      this.$store.commit(SETPRELOADER_STATE, true)

      await axios.get('catalog/section' + query)
        .then((response) => {
          this.sections = response.data?.data;
          this.paginator = response.data?.meta ?? {};
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push('/login');
          }
        })
        .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
    },
    getQuery() {
      const result = {};

      if (this.query.sectionId) {
        result['section_id'] = this.query.sectionId
      }
      if (this.query.page) {
        result['page'] = this.query.page
      }
      if (this.query.q) {
        result['q'] = this.query.q
      }
      if (this.tempSort) {
        const sort = this.sortConfig.find((e) => e.field === this.tempSort)
        if (sort) {
          result['sort'] = {
            by: sort.options.by,
            order: sort.options.order
          }
        }
      }

      if (Reflect.ownKeys(result).length) {
        const qs = require('qs');
        return `?${qs.stringify(result)}`
      }

      return ''
    },
    getSectionById(id) {
      return this.sections.find((e) => e.id === id)
    },
    setPath() {
      const q = this.getQuery()
      this.$router.push({
        path: 'catalog-sections' + q,
      })
    },
    setSelectedSection(value) {
      if (value) {
        this.selectedSection.title = value.title ?? ''
        this.selectedSection.id = value.id ?? 0
        this.selectedSection.parentId = value.parent_id ?? 0
      } else {
        this.selectedSection = {
          title: '',
          id: 0,
          parentId: 0
        }
      }
    },
    onSearch() {
      this.query.page = 1
      this.query.sectionId = 0
      this.tempSort = ''
      this.setSelectedSection()
      this.setPath()
    },
    onSection(id) {
      this.query.q = ''
      this.query.page = 1
      this.tempSort = ''
      this.query.sectionId = id
      const section = this.getSectionById(id)
      if (section) {
        this.setSelectedSection(section)
      } else if (id) {
        this.fetchDetailSection(id)
      } else {
        this.setSelectedSection()
      }
      this.setPath()
    },
    onSort() {
      this.setPath();
    },
    onParentSection() {
      if (this.selectedSection.parentId) {
        this.onSection(this.selectedSection.parentId)
      } else if (this.query.sectionId) {
        this.onSection(null)
      }
    },
    onHide(id) {
      const payload = {
        section: id
      }
      axios.post(`/catalog/section/${id}/hide`, payload)
        .then(() => { this.initSections() })
        .catch(() => { })
    },
    onShow(id) {
      const payload = {
        section: id
      }
      axios.post(`/catalog/section/${id}/restore`, payload)
        .then(() => { this.initSections() })
        .catch(() => { })
    },
    onPage(pageNum) {
      this.query.page = pageNum || 1;
      this.setPath()
    },
    onUpdateRow: function (index) {
      let id = this.sections[index].id;
      this.$router.push('/catalog-section/' + id + '/update');
    },
    onRootSection() {
      this.onSection(null)
    },
    async initParams(query) {
      if (!query) {
        return
      }
      if (query.section_id) {
        this.query.sectionId = Number.parseInt(query.section_id)
      }
      if (query.page) {
        this.query.page = query.page
      }
      if (query.q) {
        this.query.q = query.q
      }
      if (query['sort[by]'] && query['sort[order]']) {
        const sort = this.sortConfig.find((e) => e.field === `${query['sort[by]']}.${query['sort[order]']}`)
        if (sort) {
          this.tempSort = sort.field
        }
      }
    },
    initSections() {
      this.fetch(this.getQuery())
        .then(() => {
          this.initSelectedSection()
        })
        .catch(() => { })
    },
    initSelectedSection() {
      let section
      if (this.sections.length && this.query.sectionId) {
        section = this.getSectionById(this.query.sectionId)
      }
      if (section) {
        this.setSelectedSection(section)
      } else {
        this.fetchDetailSection(this.query.sectionId)
      }
    }
  }
}
</script>

<style>
.button-name-section span {
  color: #606266;
}

.button-name-section:hover span {
  color: #409EFF;
}

.catalog-sections-page__top-buttons {
  margin: 12px 0;
}
</style>